import { render, staticRenderFns } from "./SmallChallengeDetail.vue?vue&type=template&id=52bac44a&scoped=true"
import script from "./SmallChallengeDetail.vue?vue&type=script&lang=js"
export * from "./SmallChallengeDetail.vue?vue&type=script&lang=js"
import style0 from "./SmallChallengeDetail.vue?vue&type=style&index=0&id=52bac44a&prod&scoped=true&lang=css"
import style1 from "./SmallChallengeDetail.vue?vue&type=style&index=1&id=52bac44a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f1c606d12331ca9397f00d9371f47138/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bac44a",
  null
  
)

export default component.exports